<template>
  <div id="changePassword">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="4" class="change-password_slim">
          <v-card elevation="10" class="change_password_card">
            <v-card-text class="change-password">
              <v-alert v-if="!!messageOk" type="success"> {{ messageOk }}</v-alert>
              <v-alert v-if="!!message" type="error"> {{ message }}</v-alert>
              <v-form
                ref="cpform"
                id="change-password-form"
                @submit.prevent="submitchange - password"
                autocomplete="off"
              >
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="8" md="8">
                    <h1 class="change-password_prihlasenie">Zmeniť Signatus heslo</h1>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" no-gutters>
                  <v-col cols="12" sm="8" md="8">
                    <form-component title="">
                      <v-text-field
                        v-model="password_new1"
                        :append-icon="showPass_new1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[
                          rules.password_new1,
                          rules.password_format_number,
                          rules.password_format_length,
                        ]"
                        :type="showPass_new1 ? 'text' : 'password'"
                        :label="'Nové heslo'"
                        class="dynamic-input-control"
                        outlined
                        @click:append="showPass_new1 = !showPass_new1"
                      ></v-text-field>
                    </form-component>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" no-gutters>
                  <v-col cols="12" sm="8" md="8">
                    <form-component title="">
                      <v-text-field
                        v-model="password_new2"
                        :append-icon="showPass_new2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.password_new2, rules.password_new2_equality]"
                        :type="showPass_new2 ? 'text' : 'password'"
                        :label="'Zopakujte heslo'"
                        class="dynamic-input-control"
                        outlined
                        @click:append="showPass_new1 = !showPass_new1"
                      ></v-text-field>
                    </form-component>
                  </v-col>
                </v-row>
              </v-form>
              <v-row align="center" justify="center" class="">
                <v-col cols="12" sm="8" md="8">
                  <v-btn color="primary" depressed @click="changePassword">Zmeniť heslo</v-btn>
                  <v-btn
                    to="/"
                    color="secondary"
                    :ripple="false"
                    plain
                    class="change-password-cancel"
                    @click="changePasswordCancel"
                    >Zrušiť</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FormComponent from '../components/FormComponent.vue';
import protectedAxios from '../auth/axios.js';
import TextBox from '../components/basic/TextBox.vue';

export default {
  components: {
    FormComponent,
    TextBox,
  },
  data() {
    return {
      showPass_new1: false,
      showPass_new2: false,
      password_new1: '',
      password_new2: '',
      message: '',
      messageOk: '',
      rules: {
        password_format_number: value => !isNaN(value) || 'Heslo musí byť číslo',
        password_format_length: value => value.length >= 4 || 'Heslo musí mať dĺžku aspoň 4 znaky',
        password_new1: value => !!value || 'Zadajte nové heslo!',
        password_new2: value => !!value || 'Zopakujte nové heslo!',
        password_new2_equality: value =>
          value == this.password_new1 || 'Heslo sa nerovná novému heslu',
      },
    };
  },
  methods: {
    changePassword() {
      this.messageOk = '';
      protectedAxios
        .post('/login/changepassword-signatus', {
          NewPass1: this.password_new1,
          NewPass2: this.password_new2,
        })
        .then(res => {
          this.message = '';
          this.messageOk = res.data;
          this.password_new1 = '';
          this.password_new2 = '';
          this.showPass_new1 = false;
          this.showPass_new2 = false;
          this.$refs.cpform.resetValidation();
        })
        .catch(e => {
          if (e.response && e.response.data) {
            this.message = e.response.data;
          } else {
            console.error(e);
          }
        });
    },
    changePasswordCancel() {
      //console.log('changePasswordCancel');
    },
  },
};
</script>
<style lang="sass"></style>
